<template>
  <div v-if="currentContent" v-html="this.currentContent"></div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "rich-content-display",
  data() {
    return {
      defaultContent: null,
      contents: [],
      currentContentId: null,
      currentContent: null,
    };
  },
  props: {
    defaultContentId: {
      type: String,
      required: false,
    },
  },
  computed: mapState({
    products: (state) => state.product.products,
    product: (state) => state.product.product,
    donationType: (state) => state.donation.donation.type,
  }),
  watch: {
    products(newVal, oldVal) {
      const contentIds = newVal.map((e) => {
        const keys = Object.keys(e.donationsettings);
        const data = [];
        for (const k of keys) {
          if (e.donationsettings[k].contentMessageId) {
            data.push(e.donationsettings[k].contentMessageId);
          }
        }
        return data;
      });
      const ids = [];
      for (const i of contentIds) {
        ids.push(...i);
      }
      this.fetchContents(ids);
    },
    product(newVal, oldVal) {
      this.loadNewContent();
    },
    donationType(newVal, oldVal) {
      this.loadNewContent();
    },
  },
  created() {
    if (this.defaultContentId) {
      this.$store
        .dispatch("getContentMessageById", this.defaultContentId)
        .then((value) => {
          this.defaultContent = value.content;
          this.loadNewContent();
        });
    }
  },
  methods: {
    async fetchContents(ids) {
      this.$store
        .dispatch("getContentMessageById", ids.join(","))
        .then((value) => {
          this.contents = value;
          this.loadNewContent();
        });
    },

    loadNewContent() {
      const settings = this.product
        ? this.product.donationsettings[this.donationType]
        : null;
      let id = null;

      // Load the selected product for the selected type if it's available for this product
      if (settings) {
        id = settings.contentMessageId;
      } else {
        // Otherwise, take the first type available
        const contentMessageId = this.product
          ? this.product.donationsettings[0].contentMessageId
          : null;
        if (contentMessageId) {
          id = contentMessageId;
        } else {
          id = this.defaultContentId;
        }
      }

      if (id) {
        this.currentContentId = id;
        const message = this.contents.find((e) => e.id === id);
        this.currentContent = message ? message.content : this.defaultContent;
      } else if (this.defaultContentId && this.defaultContent) {
        this.currentContentId = this.defaultContentId;
        this.currentContent = this.defaultContent;
      } else {
        this.currentContentId = null;
        this.currentContent = null;
      }
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// RichContentDisplay.vue?1b3520a2